import { ICountry } from 'models';
import { GetAllFactory } from './base.service';
import CrudService from './crud.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'countries';
const SERVICE_NAME = 'Country';

// TODO: Remove this
export default new CrudService<ICountry>(SERVICE_NAME, BASE_URL);

export const GetAll = GetAllFactory<ICountry, BaseGetAllParams>(BASE_URL);
